
  var _styles = {
  "two-col-container": {
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "height": "2.18667rem",
    "width": "100%",
    "boxSizing": "border-box",
    "overflow": "hidden"
  },
  "two-col-left": {
    "width": "2rem",
    "height": "100%",
    "paddingTop": "0.34667rem",
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem",
    "overflow": "hidden"
  },
  "two-col-left-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "fontSize": 0,
    "overflow": "hidden"
  },
  "two-col-right": {
    "flexGrow": 1,
    "marginRight": "0.13333rem",
    "marginTop": "0.05333rem",
    "overflow": "hidden",
    "width": "2.44rem",
    "height": "100%",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "center"
  }
};



  module.exports = _styles;
  